export var name = 'app.commerceDetailBarHeight';
export var supports = function () {
    return true;
};
